const s = "_input_s9lh8_13", i = "_htmlSize_s9lh8_34", l = "_isBoolean_s9lh8_98", _ = "_isSwitch_s9lh8_110", t = "_isDisabled_s9lh8_171", n = "_isInvalid_s9lh8_175", h = "_shake_s9lh8_1", e = {
  input: s,
  htmlSize: i,
  isBoolean: l,
  isSwitch: _,
  isDisabled: t,
  isInvalid: n,
  shake: h
};
export {
  e as default,
  i as htmlSize,
  s as input,
  l as isBoolean,
  t as isDisabled,
  n as isInvalid,
  _ as isSwitch,
  h as shake
};
//# sourceMappingURL=input.module.less.js.map
